import React from 'react';
import {
    selectCapsuleSymbolBindingFromState,
    WidgetPanelDetailProps,
} from 'widgets/supportVisualisation/Content/Widgets/WidgetPanel';
import JsonPanel from 'utils/components/JsonPanel/JsonPanel';

import { buildData } from 'widgets/liquiditySummary/volumeCapsule/components/volumeCapsuleData';
import { toLiquidityRequestUid } from 'widgets/liquiditySummary/store/data/LiquiditySummaryStreamRequest';

export interface WidgetPanelVolumeCapsuleProps extends WidgetPanelDetailProps {
    mode: 'streamData' | 'data';
}

export default function WidgetPanelVolumeCapsule(
    props: WidgetPanelVolumeCapsuleProps
) {
    const {
        mode,
        exchangeRate,
        selection: { selectedSymbolQuantity },
        state,
    } = props;

    const symbolBinding = selectCapsuleSymbolBindingFromState(props);

    if (!symbolBinding) {
        return <></>;
    }

    const { symbol, source } = symbolBinding;

    const qty =
        source === 'Portfolio Selection'
            ? selectedSymbolQuantity?.qty
            : undefined;
    const requestUid = toLiquidityRequestUid(symbol, {}, qty ?? 1);
    const streamData = state.state.streams.data.liquidity[requestUid]?.data;
    const data = buildData(streamData, exchangeRate);

    if (mode === 'streamData') {
        return <JsonPanel data={streamData} />;
    }

    return (
        <div className="widget-panel">
            <div className="title">Symbol Capsule Data</div>
            <div className="field">
                <span className={'label'}>Symbol:</span>
                {symbol}
            </div>
            <div className="field">
                <span className={'label'}>Source</span>
                {source}
            </div>

            <JsonPanel data={data} />
        </div>
    );
}

export function addVolumeTilePanes(
    detailProps: WidgetPanelDetailProps,
    panes: { menuItem: string; render: () => JSX.Element }[]
) {
    const render = () => (
        <WidgetPanelVolumeCapsule {...detailProps} mode="data" />
    );
    panes.push({
        menuItem: 'Data',
        render,
    });

    const renderTs = () => (
        <WidgetPanelVolumeCapsule {...detailProps} mode="streamData" />
    );
    panes.push({
        menuItem: 'Stream',
        render: renderTs,
    });
}
